// extracted by mini-css-extract-plugin
export var addToCartButton = "_u0-b";
export var arrowButtonContainer = "_u0-9";
export var arrowButtonIcon = "_u0-a";
export var carouselArrowButton = "_u0-6";
export var carouselElementContainer = "_u0-1";
export var left = "_u0-7";
export var productDisplayCarouselContainer = "_u0-0";
export var productTileContainer = "_u0-2";
export var productTileImage = "_u0-4";
export var productTileImageContainer = "_u0-3";
export var productTileTitle = "_u0-5";
export var right = "_u0-8";
export var sliderOverflow = "_u0-c";